"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _useQuery3 = _interopRequireDefault(require("../../../useQuery.js"));
var _Chart = _interopRequireDefault(require("./Chart"));
var _summaryChartQuery = _interopRequireDefault(require("./summaryChartQuery.graphql"));
var _round2 = _interopRequireDefault(require("lodash/round"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Component = function Component(props) {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    hidden = _useState2[0],
    setHidden = _useState2[1];
  var _props$settings = props.settings,
    title = _props$settings.title,
    description = _props$settings.description,
    show = _props$settings.show,
    chart = _props$settings.chart;
  var _useQuery = (0, _useQuery3["default"])({
      query: props.query ? props.query : _summaryChartQuery["default"],
      variables: props.filters
    }),
    _useQuery2 = _slicedToArray(_useQuery, 2),
    data = _useQuery2[0],
    loading = _useQuery2[1];

  // Nivo charts sometimes dont render. Not sure what is going on. This function prevents chart render before parent element can render which seems to fix the problem.
  // Additional notes: Charts need parent element to have an explicit height to render. The chart is creating a parent div which uses a percent height. If this div is modified in the DOM after render, the chart will draw.
  // More notes: This is only happening in Report Center GUI. Does not happen in Reports GUI.
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setHidden(false);
    }, 300);
  }, []);
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var chartData = props.convertDataStructure(data);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].overallTable
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold',
      fontSize: '1.5em'
    }
  }, title)), /*#__PURE__*/_react["default"].createElement("div", null, description), hidden ? /*#__PURE__*/_react["default"].createElement("div", null) : /*#__PURE__*/_react["default"].createElement(_Chart["default"], {
    data: chartData,
    settings: chart
  })));
};
Component.propTypes = {
  settings: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  filters: _propTypes["default"].object
};
Component.defaultProps = {
  filters: {},
  convertDataStructure: function convertDataStructure(data) {
    // console.log(data);
    var convertedData = [];
    if (data && data.roles.participantList.length > 0) {
      var getTeenScores = function getTeenScores() {
        var teenPreScores = [];
        var teenPostScores = [];
        data.roles.participantList.forEach(function (participant) {
          participant.teenList.forEach(function (teen) {
            var teenPre = teen.devTags.YouthPreScore;
            var teenPost = teen.devTags.YouthPostScore;
            if (teenPre !== null) {
              teenPreScores.push(Number(teenPre));
            }
            if (teenPost !== null) {
              teenPostScores.push(Number(teenPost));
            }
          });
        });
        var preScore = (0, _round2["default"])((0, _mean2["default"])(teenPreScores), 1);
        var postScore = (0, _round2["default"])((0, _mean2["default"])(teenPostScores), 1);
        return {
          pre: Number.isNaN(preScore) ? null : preScore,
          post: Number.isNaN(postScore) ? null : postScore
        };
      };
      var getCaregiverScores = function getCaregiverScores() {
        var caregiverPreScores = [];
        var caregiverPostScores = [];
        data.roles.participantList.forEach(function (participant) {
          participant.caregiverList.forEach(function (caregiver) {
            var caregiverPre = caregiver.devTags.CaregiverPreScore;
            var caregiverPost = caregiver.devTags.CaregiverPostScore;
            if (caregiverPre !== null) {
              caregiverPreScores.push(Number(caregiverPre));
            }
            if (caregiverPost !== null) {
              caregiverPostScores.push(Number(caregiverPost));
            }
          });
        });
        var preScore = (0, _round2["default"])((0, _mean2["default"])(caregiverPreScores), 1);
        var postScore = (0, _round2["default"])((0, _mean2["default"])(caregiverPostScores), 1);
        return {
          pre: Number.isNaN(preScore) ? null : preScore,
          post: Number.isNaN(postScore) ? null : postScore
        };
      };
      convertedData = [{
        id: 'Teen Summary',
        color: '#3673b6',
        data: [{
          x: '',
          y: null
        }, {
          x: 'Pre',
          y: getTeenScores().pre
        }, {
          x: 'Post',
          y: getTeenScores().post
        }, {
          x: ' ',
          y: null
        }]
      }, {
        id: 'Caregiver Summary',
        color: '#65a84b',
        data: [{
          x: '',
          y: null
        }, {
          x: 'Pre',
          y: getCaregiverScores().pre
        }, {
          x: 'Post',
          y: getCaregiverScores().post
        }, {
          x: ' ',
          y: null
        }]
      }];
    } else {
      convertedData = [{
        id: 'Teen Summary',
        color: '#3673b6',
        data: [{
          x: '',
          y: null
        }, {
          x: 'Pre',
          y: 64.25
        }, {
          x: 'Post',
          y: 73.75
        }, {
          x: ' ',
          y: null
        }]
      }, {
        id: 'Caregiver Summary',
        color: '#65a84b',
        data: [{
          x: '',
          y: null
        }, {
          x: 'Pre',
          y: 70
        }, {
          x: 'Post',
          y: 75
        }, {
          x: ' ',
          y: null
        }]
      }];
    }
    // console.log({ convertedData });
    return convertedData;
  }
};
var _default = exports["default"] = Component;